import React from 'react';
import PropTypes from 'prop-types';
import ClientMobilePanel from './ClientMobilePanel';
import NotaClientPanel from './NotaClientPanel';
import NotaClientImagePanel from './NotaClientImagePanel';
import SmartBanner from './SmartBanner';
import NativeBanner from './NativeBanner';
import { constants } from './panel-constants';
import { getCookie, extractBrandingImageProperty } from '../../util/misc';

const {
  OLP_VIEW,
  NOT_A_CLIENT_IMAGE_PANEL,
  NOT_A_CLIENT_PANEL,
  CLIENT_MOBILE_PANEL,
  SMART_BANNER,
} = constants;

class MainPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNativeBanner: false,
      nativeBannerPlatform: null,
    };
  }

  componentDidMount() {
    const { isMobileDevice, enableSmartBanner } = this.props;

    if (isMobileDevice && enableSmartBanner) {
      setTimeout(() => {
        this.checkAppInstallationAndShowBanner();
      }, 1000);
    }
  }

  componentWillUnmount() {
    document.body.style.paddingTop = '0';
  }

  checkAppInstallationAndShowBanner = () => {
    const { userAgent } = navigator;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);

    if (!isAndroid && !isIOS) {
      console.log('Desktop detected - no banner needed');
      return;
    }

    let appInstalled = false;
    let checkCompleted = false;

    const testFrame = document.createElement('iframe');
    testFrame.style.display = 'none';
    document.body.appendChild(testFrame);

    const cleanup = () => {
      if (testFrame && testFrame.parentNode) {
        testFrame.parentNode.removeChild(testFrame);
      }
    };

    const completeCheck = (installed) => {
      if (checkCompleted) return;
      checkCompleted = true;

      console.log(
        'App installation check completed:',
        installed ? 'INSTALLED' : 'NOT INSTALLED',
      );

      if (!installed) {
        this.setState({
          showNativeBanner: true,
          nativeBannerPlatform: isAndroid ? 'android' : 'ios',
        });
      } else {
        console.log('ADP Mobile app is already installed, banner not shown');
      }

      cleanup();
    };

    try {
      if (isAndroid) {
        const visibilityHandler = () => {
          if (document.hidden || document.webkitHidden) {
            appInstalled = true;
            document.removeEventListener('visibilitychange', visibilityHandler);
            document.removeEventListener(
              'webkitvisibilitychange',
              visibilityHandler,
            );
            completeCheck(true);
          }
        };

        document.addEventListener('visibilitychange', visibilityHandler);
        document.addEventListener('webkitvisibilitychange', visibilityHandler);
        testFrame.src = 'adpmobile://';

        setTimeout(() => {
          document.removeEventListener('visibilitychange', visibilityHandler);
          document.removeEventListener(
            'webkitvisibilitychange',
            visibilityHandler,
          );
          completeCheck(false);
        }, 2000);
      } else if (isIOS) {
        const timeoutHandler = setTimeout(() => {
          completeCheck(false);
        }, 2000);

        const visibilityHandler = () => {
          if (document.hidden || document.webkitHidden) {
            clearTimeout(timeoutHandler);
            document.removeEventListener('visibilitychange', visibilityHandler);
            completeCheck(true);
          }
        };

        document.addEventListener('visibilitychange', visibilityHandler);
        testFrame.src = 'adpmobile://';
      }
    } catch (error) {
      console.log('App detection error:', error);
      completeCheck(false);
    }
  };

  handleCloseBanner = () => {
    this.setState({ showNativeBanner: false });
    document.body.style.paddingTop = '0';
  };

  render() {
    const {
      isMobileDevice,
      locale,
      clientPanel,
      redirectURL,
      clientPanelMobile,
      brandingStyles,
      isBrandingStylesLoaded,
      setBrandingStyles,
      setBrandingStylesLoaded,
      enableSmartBanner,
    } = this.props;

    const { showNativeBanner, nativeBannerPlatform } = this.state;

    const {
      headlineText,
      bodyText,
      linkText,
      linkUrl,
      image: imageProp,
      backgroundColor,
    } = clientPanel || '';

    const {
      bodyText: mobilebodyText,
      buttonText: mobilebuttonText,
      buttonUrl: mobilebuttonUrl,
      headlineText: mobileheadlineText,
      cancelButtonText: mobilecancelButtonText,
    } = clientPanelMobile || '';

    const imageUrl = extractBrandingImageProperty(imageProp, locale);
    const imageAlignment = imageProp && imageProp.alignment
      ? imageProp.alignment.toUpperCase()
      : 'LEFT';
    const {
      weight: clientPanelHeaderTextStyle,
      color: clientPanelHeaderTextColor,
    } = headlineText || '';

    const { i18n: mobilebodyLocaleProp } = mobilebodyText || '';
    const { i18n: mobilebuttonLocaleProp } = mobilebuttonText || '';
    const { i18n: mobileheadlineLocaleProp } = mobileheadlineText || '';
    const { i18n: mobilecancelButtonLocaleProp } = mobilecancelButtonText || '';

    const {
      weight: clientPanelBodyTextStyle,
      color: clientPanelBodyTextColor,
    } = bodyText || '';

    const { i18n: headlineLocaleProp } = headlineText || '';
    const { i18n: linkTextLocaleProp } = linkText || '';
    const { i18n: bodyTextLocaleProp } = bodyText || '';
    const { i18n: linkUrlLocaleProp } = linkUrl || '';

    const styles = {
      clientPanel: {
        clientHeader: {
          color: clientPanelHeaderTextColor,
          fontWeight: clientPanelHeaderTextStyle,
        },
        clientBody: {
          color: clientPanelBodyTextColor,
          fontWeight: clientPanelBodyTextStyle,
        },
      },
    };

    if (!isBrandingStylesLoaded) {
      setBrandingStyles(styles);
      setBrandingStylesLoaded(true);
    }

    let logpanel;

    if (enableSmartBanner && isMobileDevice && !getCookie(OLP_VIEW)) {
      logpanel = SMART_BANNER;
    } else if (clientPanelMobile && isMobileDevice && !getCookie(OLP_VIEW)) {
      logpanel = CLIENT_MOBILE_PANEL;
    } else if (clientPanel && clientPanel.image && !isMobileDevice) {
      logpanel = NOT_A_CLIENT_IMAGE_PANEL;
    } else if (clientPanel && !clientPanel.image) {
      logpanel = NOT_A_CLIENT_PANEL;
    }

    return (
      <>
        { /* Native Banner - rendered at the top level for fixed positioning */ }
        { showNativeBanner && (
          <NativeBanner
            platform={ nativeBannerPlatform }
            onClose={ this.handleCloseBanner }
          />
        ) }

        <div
          style={ { flex: 1 } }
          className="mt-6"
        >
          <div id="loginPanel">
            { (() => {
              switch (logpanel) {
                case SMART_BANNER:
                  return (
                    <div id="smartBannerDiv">
                      <SmartBanner
                        id="smartBanner"
                        key="smartBanner"
                        redirectURL={ redirectURL }
                        locale={ locale }
                        { ...this.props }
                      />
                    </div>
                  );
                case CLIENT_MOBILE_PANEL:
                  return (
                    <div id="mobileClientPanelDiv">
                      <ClientMobilePanel
                        id="mobileClientPanel"
                        key="mobileClientPanel"
                        bodyText={ mobilebodyLocaleProp }
                        headlineText={ mobileheadlineLocaleProp }
                        buttonUrl={ mobilebuttonUrl }
                        buttonText={ mobilebuttonLocaleProp }
                        cancelButtonText={ mobilecancelButtonLocaleProp }
                        redirectURL={ redirectURL }
                        styles={ brandingStyles || {} }
                        locale={ locale }
                        { ...this.props }
                      />
                    </div>
                  );
                case NOT_A_CLIENT_IMAGE_PANEL:
                  return (
                    <div id="notaClientPanelDiv">
                      <hr
                        className="border-0 border-t-2 border-solid border-dark"
                        aria-hidden="true"
                      />
                      <NotaClientImagePanel
                        id="notaClientImagePanel"
                        key="notaClientImagePanel"
                        headlineText={ headlineLocaleProp }
                        bodyText={ bodyTextLocaleProp }
                        linkText={ linkTextLocaleProp }
                        linkUrl={ linkUrlLocaleProp }
                        imageUrl={ imageUrl }
                        backgroundColor={ backgroundColor }
                        imageAlignment={ imageAlignment }
                        redirectURL={ redirectURL }
                        styles={ brandingStyles || {} }
                        locale={ locale }
                      />
                    </div>
                  );
                case NOT_A_CLIENT_PANEL:
                  return (
                    <div id="notaClientPanelDiv">
                      <hr
                        className="border-0 border-t-2 border-solid border-dark"
                        aria-hidden="true"
                      />
                      <NotaClientPanel
                        id="notaClientPanel"
                        key="notaClientPanel"
                        headlineText={ headlineLocaleProp }
                        bodyText={ bodyTextLocaleProp }
                        linkText={ linkTextLocaleProp }
                        linkUrl={ linkUrlLocaleProp }
                        backgroundColor={ backgroundColor }
                        redirectURL={ redirectURL }
                        styles={ brandingStyles || {} }
                        locale={ locale }
                      />
                    </div>
                  );
                default:
                  return null;
              }
            })() }
          </div>
        </div>
      </>
    );
  }
}

MainPanel.propTypes = {
  isMobileDevice: PropTypes.bool,
  background: PropTypes.shape({
    default: PropTypes.string.isRequired,
  }),
  clientPanelMobile: PropTypes.shape({
    bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    buttonUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    headlineText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    cancelButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  clientPanel: PropTypes.shape({
    headlineText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    linkText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    linkUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    backgroundColor: PropTypes.string,
  }),
  brandingStyles: PropTypes.shape({
    clientPanel: PropTypes.shape({
      clientHeader: PropTypes.string,
      clientBody: PropTypes.string,
    }),
  }),
  redirectURL: PropTypes.func.isRequired,
  locale: PropTypes.string,
  setBrandingStyles: PropTypes.func,
  isBrandingStylesLoaded: PropTypes.bool,
  setBrandingStylesLoaded: PropTypes.func,
  enableSmartBanner: PropTypes.bool,
};

export default MainPanel;
